import { createSelector } from 'reselect';

import { getBorrowersOptions, getPersonFullName } from 'utils/loanApplication';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectBorrowers = createSelector(selectLoanApplication, ({ borrowers }) => borrowers);

const selectBorrowersValues = createSelector(selectBorrowers, borrowers =>
  Object.values(borrowers)?.sort(({ orderNumber }, { orderNumber: nextOrderNumber }) => {
    const equalOrLess = orderNumber === nextOrderNumber ? 0 : -1;

    return orderNumber > nextOrderNumber ? 1 : equalOrLess;
  }),
);

export const selectExtendedBorrowers = createSelector(selectBorrowersValues, borrowers =>
  borrowers?.map(borrower => ({
    ...borrower,
    fullName: getPersonFullName(borrower),
    fullNameWithMiddleName: getPersonFullName({ ...borrower, isWithMiddleName: true }),
  })),
);

export const selectLoanApplicationBorrowerOptions = createSelector(
  selectExtendedBorrowers,
  borrowers => getBorrowersOptions(borrowers),
);
